import { j as t } from "../../_virtual/jsx-runtime.js";
const x = ({
  width: r = 20,
  height: o = 20,
  viewBox: n = "0 0 20 20",
  fill: s = "currentColor",
  ...e
}) => /* @__PURE__ */ t.jsxs(
  "svg",
  {
    width: r,
    height: o,
    viewBox: n,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...e,
    children: [
      /* @__PURE__ */ t.jsx(
        "path",
        {
          d: "M18.3334 11.6667V16.6667H16.6667V13.3334H3.33335V16.6667H1.66669V3.33337H3.33335V11.6667C6.14354 11.6667 4.40225 11.6667 18.3334 11.6667Z",
          fill: s
        }
      ),
      /* @__PURE__ */ t.jsx(
        "path",
        {
          d: "M14.4154 7.17888L13.1916 8.40268L10.7275 5.93866L11.9513 4.71486L14.4154 7.17888Z",
          fill: s
        }
      ),
      /* @__PURE__ */ t.jsx(
        "path",
        {
          d: "M11.9572 4.71013L10.7334 3.48633L7.04083 7.17887L8.26463 8.40267L11.9572 4.71013Z",
          fill: s
        }
      )
    ]
  }
);
export {
  x as default
};
